module.exports = __webpack_public_path__ + "static/media/TOC_About_Localfnf_1.1.b141c431.pdf";